import {
  SET_ADMIN_LOOKUPS_DATA,
  SET_ADMIN_LOOKUPS_LOADER,
  SET_ADMIN_LOOKUPS_FILTERS,
  CLEAR_ADMIN_LOOKUPS_FILTERS,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  rows: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  loading: false,
  applyFilters: false,
  filterSize: null,
  filters: {},
};

const adminLookupsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ADMIN_LOOKUPS_DATA:
      return {
        ...state,
        rows: payload.rows,
        rowsCount: payload.count,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
      };
    case SET_ADMIN_LOOKUPS_LOADER:
      return { ...state, loading: payload };
    case SET_ADMIN_LOOKUPS_FILTERS:
      return {
        ...state,
        applyFilters: payload.applyFilters,
        filterSize: payload.filterSize,
        filters: payload.filters,
      };
    case CLEAR_ADMIN_LOOKUPS_FILTERS:
      return { ...state, applyFilters: false, filterSize: null, filters: {} };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { adminLookupsReducers };
